import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "sourceSelect",
    ]
    static values = { wrapperSelector: String }

    targetInputWrapper;

    connect() {
        this.targetInputWrapper = document.getElementById(this.wrapperSelectorValue);
        // Avoid UI flickering
        Turbolinks.clearCache();
        // Delay to let Select2 instances to correctly initialize
        setTimeout(() => {
            this.toggle();
        }, 10)
    }

    toggle() {
        let sourceSelected = this.sourceSelectTarget.options[this.sourceSelectTarget.selectedIndex];
        let displayTarget = false;
        if (sourceSelected) {
            if (sourceSelected.dataset.toggleVisibility) {
                displayTarget = sourceSelected.dataset.toggleVisibility === 'true';
            } else {
                displayTarget = sourceSelected.text.length > 0 ;
            }
        }
        this.targetInputWrapper.style.display = displayTarget ? "block" : "none";
    }

}